<div class="settings">
  <!-- <div (click)="GoBack()" class="btn btn p-1" mat-button type="button">
    <mat-icon class="icon-lg" svgIcon="mat:arrow_back"></mat-icon>
  </div> -->

  <input type="text" placeholder="access code..." [(ngModel)]="accesscode" class="norightmargin"
    (keydown.enter)="connectClicked()" />
  <input type="text" placeholder="Full Name" class="norightmargin" [(ngModel)]="proctorfullname"
    (keydown.enter)="connectClicked()" />
  <input type="button" class="btn btn-success p-1" [disabled]="procteesComponent.connecting" (click)="connectClicked()"
    [value]="procteesComponent.connecting? 'Connecting':'Connect'" *ngIf="!procteesComponent.connected" />
  <input type="button" class="btn btn-danger p-1" (click)="disconnectClicked()" value="Disconnect"
    *ngIf="procteesComponent.connected" />
  Proctees per Page:
  <select [(ngModel)]="settings.procteesperpage" (ngModelChange)="numProcteesChanged()">
    <option>1</option>
    <option>3</option>
    <option>6</option>
    <option>9</option>
    <option>12</option>
  </select>
  Dual View Orientation:
  <select [(ngModel)]="settings.dualvieworientation" (ngModelChange)="dualViewOrientationChanged()">
    <option value="horizontal">Stack Horizontally</option>
    <option value="vertical">Stack Vertically</option>
  </select>
  Filter Page by:
  <select [(ngModel)]="settings.filterby" (ngModelChange)="filterByChanged()">
    <option value="" selected>None</option>
    <option value="highlighted">Highlighted</option>
    <option value="attentionrequested">Requesting attention</option>
    <option value="proctorpaused">Paused</option>
    <option value="aiFlagged">Ai-Flagged</option>
  </select>
  <span class="ml-3">Proctees count: {{candidates}}</span>
  <span class="ml-3" [ngClass]="{'text-danger': requireAttention > 0}">Proctees requesting attention:
    {{requireAttention}}</span>
  <span class="ml-3" [ngClass]="{'text-danger': aiFlags > 0}">A.I Flags: {{aiFlags}}</span>
  <span style="display: none;">
    Seconds per Page:
    <input type="number" min="0" [(ngModel)]="settings.secondsperpage" (ngModelChange)="secondsPerPageChanged()" />
    <label>Auto Switch Page:</label>
    <input type="checkbox" [(ngModel)]="settings.autoswitchpage" (ngModelChange)="autoswitchChanged()" />
    <label>Search:</label>
    <input type="text" placeholder="search..." disabled />
  </span>
</div>